














import { Component, Inject, Vue } from 'vue-property-decorator'
import { toV, getSelectedCityId } from '@/app/core/utils'

import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

interface IShopDetail {
  addressDistrict: string
  addressProvince: string
  addressCity:string
  addressStreet: string
  mobile: string | number
  latitude: string
  longitude: string
  storeName: string
  distanceKm: string
}

@Component
export default class Address extends Vue {
  @Inject({ default: null })
  telTrackParams!: any
  @Inject({ default: null })
  addressTrackParams!: any
  
  @shopHomeModule.State shopDetail!: IShopDetail
  get addressLocation() {
    return this.shopDetail && this.shopDetail.addressStreet
  }
  get completeAddress() {
    return this.shopDetail && (this.shopDetail.addressCity + this.shopDetail.addressStreet)
  }
  get showDistance() {
    return parseInt(this.shopDetail && this.shopDetail.distanceKm && this.shopDetail.distanceKm) > 60 ? '>60km' : this.shopDetail && this.shopDetail.distanceKm && '距您' + this.shopDetail.distanceKm
  }
  makeTel() {
    window.location.href = `tel:${this.shopDetail && this.shopDetail.mobile}`
    this.telTrackParams && this.$newClickTracker(this.telTrackParams)
  }
  goToMap() {
    this.addressTrackParams && this.$newClickTracker(this.addressTrackParams)
    toV({
      name: 'map',
      query: {
        lng: this.shopDetail && this.shopDetail.longitude,
        lat: this.shopDetail && this.shopDetail.latitude,
        desc: this.shopDetail && this.shopDetail.storeName,
        address: this.completeAddress
      }
    })
  }
}
